
import Search from 'vux/src/components/search/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import config from '@/config/index'
import Scroll from '@/components/scroller'
import { getClassify, getProductList } from '@/api/youzheng.js'
export default {
name: 'productList',
components: {
Search,
Flexbox,
FlexboxItem,
LoadMore,
XButton,
Scroll
},
data () {
return {
searchVal: '',
baseUrl: config.baseUrl,
classifyList: [{
producttype: 0,
producttypename: '全部'
}],
goodsList: [],
rows: 10,
page: 1,
notFirstLoad: false,
loadMoreDom: null,
selected: this.$route.params.producttype ? this.$route.params.producttype : 0,
type: this.$route.params.producttype,
tablist: [{
name: '兑换量',
orderdesc: 0,
ordertype: 0
}, {
name: '分值',
orderdesc: 0,
ordertype: 0
}, {
name: '库存量',
orderdesc: 0,
ordertype: 0
}],
ordertype: 0,
orderdesc: 0
}
},
created () {
this.getGoodstype()
this.getlist()
},
activated () {
this.listDom.scrollTop = config.scrollPosition.y
},
beforeRouteLeave (to, from, next) {
config.scrollPosition.y = this.listDom.scrollTop
next()
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')

},
methods: {

getGoodstype () {
getClassify().then(res => {
if (res.returnValue !== '' && res.returnValue.length > 0) {
res.returnValue.forEach((item, index) => {
this.classifyList.push({
producttype: item.producttype,
producttypename: item.producttypename
})
})
}
})
},

changeClassify (producttype, done) {
this.selected = producttype
this.page = 1
this.getlist('search', done, this.ordertype, this.orderdesc)
},

ontab (item, index, done) {
this.page = 1
console.log('item', item)
console.log('index', index)
console.log('done', done)
if (index === 0) {
this.tablist[index].ordertype = 2
this.ordertype = 2
} else if (index === 1) {
this.tablist[index].ordertype = 1
this.ordertype = 1
} else {
this.tablist[index].ordertype = 3
this.ordertype = 3
}
this.tablist.forEach((item, i) => {
if (i === index) {
if (item.orderdesc === 0) {
item.orderdesc = 1
this.orderdesc = 1
} else if (item.orderdesc === 1) {
item.orderdesc = 2
this.orderdesc = 2
} else if (item.orderdesc === 2) {
item.orderdesc = 0
item.ordertype = 0
this.orderdesc = 0
}
} else {
item.orderdesc = 0
}
})
this.getlist('search', done, this.tablist[index].ordertype, this.tablist[index].orderdesc)
},

godetail (id) {
this.$router.push({ name: 'mallWechatPayProductDetail', params: { id: id } })
},

getlist (type, done, ordertype, orderdesc) {
getProductList({
prodname: this.searchVal,
usercredit: 0,
ordertype: ordertype,
grouptype: 0,
producttype: this.selected,
isnew: 0,
page: this.page,
rows: this.rows,
orderdesc: orderdesc
}).then(res => {
this.notFirstLoad = true
if (type === 'refresh' || type === 'search') {
this.goodsList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
res.returnValue.list.forEach(item => {
this.goodsList.push({
ID: item.ID,
PRODNAME: item.PRODNAME,
TITLEIMG: item.TITLEIMG,
CREDIT: item.CREDIT,
STARTDATE: item.STARTDATE,
AMOUNT: item.AMOUNT,
EXCHAGE: item.EXCHAGE,
GROUPTYPE: item.GROUPTYPE,
TIMELIMIT: item.TIMELIMIT,
PRICE: item.PRICE
})
})
}
if (res.returnValue.list.length === 0 || res.returnValue.count < this.rows) {
this.loadMoreDom.innerHTML = '<span style="display: none;">加载中……</span> <span>我也是有底线的～o～</span>'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
}).catch(() => {
this.notFirstLoad = true
done && done()
})
},

refresh (done) {
this.page = 1
this.tablist.forEach(res => {
res.orderdesc = 0
})
this.loadMoreDom.innerText = '加载中...'
this.getlist('refresh', done)
},

loadMore (done) {
this.page++
this.loadMoreDom.innerHTML = '<span>加载中……</span><span style="display: none;">我也是有底线的～o～</span>'
this.getlist('more', done, this.ordertype, this.orderdesc)
},

exchange (id) {
this.$router.push({ name: 'mallWechatPaySubmitOrders', params: { id: id } })
},

onSearch () {
this.getlist('search')
},

onCancel () {
this.searchVal = ''
this.getlist('search')
}
}
}
